import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { X } from 'lucide-react';
import { useCallback, useEffect, useState } from 'react';

import { BookText } from 'lucide-react';

export default function QuickGuideDialogue() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('');
  const [description, setDescription] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [fetchingFaq, setFetchingFaq] = useState([]);

  // Fetch Categories API
  const fetchFaqs = useCallback(async () => {
    setFetchingFaq(true);
    setFaqs([]);
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/faq/get-all`, {
        method: 'GET',
      });
      const data = await response.json();
      setFaqs(data.data || []);
    } catch (error) {
      setFaqs([]);
    } finally {
      setFetchingFaq(false);
    }
  }, []);

  // Fetch categories list
  useEffect(() => {
    fetchFaqs();
  }, [fetchFaqs]);

  const handleSelect = (heading, description) => {
    setActive(heading);
    setDescription(description);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger onClick={() => setOpen(true)} asChild>
        <div>
          {/* <Button variant="default" className="rounded-full mb-2 cursor-pointer text-xs px-1 me-3 sm:text-[15px]">
          <BookText />SmartGuy&reg; Quick Guide
        </Button> */}
          SmartGuy&reg; Quick Guide
        </div>
      </PopoverTrigger>
      <PopoverContent className="me-4 w-[380px] border-0 bg-transparent shadow-none">
        <Card className={`gap-0 rounded-lg border border-gray-200 bg-white py-4 shadow-2xl`}>
          <CardHeader className={`flex items-center justify-between pb-3`}>
            <CardTitle className={`text-primary flex items-center justify-center`}>
              <BookText className="mr-2" />
              <span>
                SmartGuy<sup className="text-sm">&reg;</sup> Quick Guide
              </span>
            </CardTitle>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setOpen(false)}
              className="h-8 w-8 p-0 hover:bg-gray-100"
            >
              <X className="h-4 w-4" />
            </Button>
          </CardHeader>
          <Separator className={`m-0 p-0`} />
          <CardContent className="pt-3">
            {description && <p className="px-3 pb-5">{description}</p>}

            <div className="grid gap-x-3 gap-y-2">
              {faqs.length > 0 &&
                faqs.map((data, index) => (
                  <Button
                    variant="default"
                    key={index}
                    className={`active block rounded-full text-start ${data?.heading === active && 'bg-primary/80'}`}
                    onClick={() => handleSelect(data?.heading, data?.answer)}
                  >
                    {data?.heading}
                  </Button>
                ))}
            </div>
          </CardContent>
        </Card>
      </PopoverContent>
    </Popover>
  );
}
